import React, { useEffect, useRef } from 'react';
import Styles from '../assets/css/layouts/sidebar.module.scss';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../assets/images/logo/Logo.png';
import { useDispatch, useSelector } from "react-redux";
import { warehousesidebar } from '../utils/sidebarData';
import { ImCancelCircle } from "react-icons/im";
import Logout from '../assets/images/Sidebar Icon/logout.png';
import { sidebarOn } from '../features/navbar/toggleSlice';
import { popUpBoxTrigger } from "../features/message/popUpSlice";
import PopUpMessage from "../utils/errors/PopUpMessage";

const Sidebar = (props) => {
  const toggleValue = useSelector(state => state.toggle.toggle);
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(sidebarOn());
  }, [location, dispatch]);

  const showPopup = (type, heading, message) => {
    dispatch(popUpBoxTrigger({
      type,
      heading,
      message,
      show: true
    }));
  };

  const handleLogoutButtonClick = async () => {
    // Show logout confirmation popup
    showPopup('success', 'Logout Successful', 'You have been successfully logged out.');
    
    // Remove token from localStorage
    localStorage.removeItem('token');
    
    await new Promise(resolve => setTimeout(resolve, 1000));
    navigate('/login');
  };

  return (
    <div className={`${Styles.sidebar} ${toggleValue ? Styles.active : ""}`}>
      <PopUpMessage />
      
      {/* Sidebar Logo */}
      <div className={`${Styles.logo} ${toggleValue ? Styles.active : ""}`}>
        <img src={Logo} alt="Logo" />
        <ImCancelCircle onClick={() => dispatch(sidebarOn())} />
      </div>

      {/* Sidebar Navigation Menu */}
      <div className={`${Styles.menu}`}>
        {warehousesidebar.map((sidebarData, index) => (
          <NavLink key={index} to={sidebarData.navigation} className={({ isActive }) => `${Styles.submenu} ${isActive ? Styles.active : ""}`} >
            <div className={`${Styles.sidebarIcon}`}>
              <img className={`${Styles.imageIcon}`} src={sidebarData.icon} alt="not supported" />
            </div>
            <p className={`${toggleValue ? Styles.active : ""}`}>{sidebarData.label}</p>
          </NavLink>
        ))}
      </div>
      <div className={`${Styles.logout}`}>
        <div className={`${Styles.subLogout}`} onClick={handleLogoutButtonClick}>
          <p className={`${toggleValue ? Styles.active : ""}`}>Logout</p>
          <div className={`${Styles.sidebarLogout}`}>
            <img src={Logout} alt="log out" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Sidebar;